import React from 'react';
import { graphql } from 'gatsby';
import { LocationList as LocationListComponent } from '../../LocationList';

export const LocationList = ({ data, ...rest }) => <LocationListComponent {...data} {...rest} />;

export const LocationListQuery = graphql`
  fragment LocationList on KFH_UmbracoLocationListComponentType {
    regions {
      id
      name
      relativeUrl
      shortDescription
      areas {
        edges {
          node {
            name
            relativeUrl
            id
          }
        }
      }
    }
  }
`;
